const sideMenushipper = [
    { label: 'Dashboard', url: '/dashboard', icon: 'fi fi-rr-dashboard' },
    {
        label: 'Buat Pesanan',
        url: '#',
        icon: 'fi fi-rr-add document',
        menus: [
            { label: 'Entri Manual', url: '/order/create/single', icon: '' },
            { label: 'Import File', url: '/order/import', icon: '' },
        ]
    },
    { label: 'Riwayat Kiriman', url: '/riwayat/all', icon: 'fi fi-rr-time-past' },
    // { label: 'Cek Ongkir', url: '/', icon: 'fi fi-rr-map-marker-home' },
    { label: 'Cek Resi', url: '/cek', icon: 'fi fi-rr-search location' },
    // { label: 'Kode Tujuan', url: '/', icon: 'fi fi-rr-road' },
    { label: 'Daftar Pesanan', url: '/order', icon: 'fi fi-rr-ballot' },
    { label: 'Riwayat Buyer', url: '/buyer', icon: 'fi fi-rr-users-alt' },
    { label: 'Admin Shipper', url: '/settings/user', icon: 'fi fi-rr-users-alt' },
    {
        label: 'BukuBos',
        url: '#',
        icon: 'fi fi-rr-document',
        menus: [
            { label: 'Saldo', url: '/saldo', icon: '' },
            { label: 'Ongkir', url: '/payment-shipper/all', icon: '' },
            { label: 'Ongkir Retur', url: '/payment-shipper/retur', icon: '' }
        ]
    },
    {
        label: 'Tiket & Klaim',
        url: '#',
        icon: 'fi fi-rr-ticket',
        menus: [{
                label: 'Buat Tiket Baru',
                url: () => {
                    // this.$root.$emit('createTicket', 3);
                },
                icon: ''
            },
            { label: 'Daftar Tiket', url: '/settings/tickets/all', icon: '' },
            { label: 'Daftar Klaim', url: '/settings/tickets/claim', icon: '' },
        ]
    },
    {
        label: 'Pengaturan',
        url: '#',
        icon: 'fi fi-rr-settings',
        menus: [
            { label: 'Profil', url: '/profile', icon: '' },
            { label: 'Pengaturan Kurir', url: '/kustom-kurir', icon: '' },
            { label: 'Verifikasi KTP', url: '/verification', icon: '' },
            { label: 'Info Ketentuan', url: '/info/ketentuan', icon: '' },
            { label: 'Cek Ongkir', url: '/cek-ongkir', icon: '' },
            // { label: 'Alamat', url: '/settings/warehouse', icon: '' },
            { label: 'Rekening', url: '/settings/rekening', icon: '' },
            // { label: 'Customer Service', url: '/settings/user', icon: '' },
            { label: 'Kode Tujuan', url: '/settings/destination', icon: '' },
            // { label: 'Kode Alamat JNE', url: '/settings/destination/jne', icon: '' },
            // { label: 'Kode Alamat IDX', url: '/settings/destination/idx', icon: '' },
            { label: 'Buat PIN otorisasi', url: '/settings/pin', icon: '' },
            { label: 'Membership', url: '/shipper/membership', icon: '' },
        ]
    },
    // { label: 'Profil', url: '/profile', icon: 'far fa-user' },
    // { label: 'Membership', url: '/', icon: 'fi fi-rr-id-badge' },
    { label: 'Affiliate', url: '/afiliasi-shipper-detail', icon: 'fi fi-rr-coins' },
    // { label: 'Pusat Bantuan', url: '/', icon: 'fi fi-rr-headset' },

];
export default sideMenushipper;